import { useState } from "react";

import ComboBox from "~/components/formElements/ComboBox";
import Input from "~/components/formElements/Input";
import type {
	AddressFormFieldsData,
	AddressFormFieldsProps,
} from "~/components/formSections/AddressFormSection/addressFormSectionTypes.ts";


const AddressFormFields = <T extends AddressFormFieldsData>({
	control,
	countryCodeSelectOptions,
	initialShowLine3 = false,
}: AddressFormFieldsProps<T>) => {
	const [showLine3, setShowLine3] = useState(initialShowLine3);

	return (
		<div className="grid gap-2 gap-y-6 sm:grid-cols-4">
			<div className="col-span-full">
				<Input
					name="addressLine1"
					control={control}
					placeholder="Musterstr. 12"
					label="Straße und Hausnummer"
				/>
			</div>

			<div className="col-span-full">
				<Input
					name="addressLine2"
					control={control}
					placeholder="c/o, Abteilung, etc."
					label="Adresszusatz"
				/>
			</div>

			{showLine3 && (
				<div className="col-span-full">
					<Input
						name="addressLine3"
						control={control}
						placeholder="Weitere Angaben"
						label="Adresszusatz"
					/>
				</div>
			)}

			{!showLine3 && (
				<div className="col-span-full">
					<button
						type="button"
						onClick={() => setShowLine3(true)}
						className="text-sm text-primary-300 hover:text-primary-200"
					>
						Weitere Adresszeile
					</button>
				</div>
			)}

			<div className="sm:col-span-1 sm:col-start-1">
				<Input
					name="postCode"
					control={control}
					placeholder="12345"
					label="PLZ"
				/>
			</div>

			<div className="sm:col-span-3">
				<Input
					name="city"
					control={control}
					placeholder="Hamburg"
					label="Stadt"
				/>
			</div>

			<div className="col-span-full">
				<ComboBox
					allowNew={false}
					name="countryCode"
					label="Land"
					control={control}
					optionsData={countryCodeSelectOptions}
				/>
			</div>
		</div>
	);
};

export default AddressFormFields;